export type SelfExclusionStep = 'form' | 'confirmation' | 'withdrawal-check';

export const selfExclusionFormID = 'self-exclusion-form';
